__turbopack_context__.v({
  "className": "cardo_87a38f1b-module__n5NIWq__className",
});
